import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'invoices-card',
    templateUrl: './invoices-card.component.html',
    styleUrls: ['./invoices-card.component.scss']
})
export class InvoicesCardComponent implements OnInit {

    @Input() invoice: any;

    @Output() emitActions: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    handleClickActions(actionFrom: any, invoice: any) {
        this.emitActions
            .emit({
                actionFrom,
                invoice
            });
    }
}
